export function isPasswordsInvalid(password, passwordConfirmation) {
  // temporary suppression per Rachel's request on 20200821
  //return false;

  /* regExp checking:
  1) password length > 8
  2) at least one  lowerCase letter 
  3) at least one upperCase letter
  4) at least one number from 0 to 9
  5) at least one special character
  6) doesnt contain any white space characters */

  //const rexExp = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W)(?!.*\s)/;

  // if(!rexExp.test(password) && process.env.NODE_ENV === 'production')
  //   return `Password has to contain at least 8 characters`;
  //   // one uppercase character, one lowercase character, one number and one special character (!, %, #, @ etc.) and no white space characters`;
  // }

  if (password.length < 2) {
    return `Password has to contain at least 2 characters`;
    //less than 8
  }
  if (password !== passwordConfirmation) {
    return `Passwords do not match`;
  }

  return '';
}
